import React from "react";

function Icon(props) {
    return (
        <img src={require("../resources/icon-" + props.icon + ".svg").default} alt={props.alt} />
    )
}

export default Icon;